import { render, staticRenderFns } from "./SelectedMapStats.vue?vue&type=template&id=5944c455&scoped=true&"
import script from "./SelectedMapStats.vue?vue&type=script&lang=js&"
export * from "./SelectedMapStats.vue?vue&type=script&lang=js&"
import style0 from "./SelectedMapStats.vue?vue&type=style&index=0&id=5944c455&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5944c455",
  null
  
)

export default component.exports